import { combineReducers } from 'redux'

import notificationsReducer from './Notifications/reducer'
import reportingReasonsReducer from './ReportingReasons/reducer'

export default function () {
  const initialState = combineReducers({
    notifications: notificationsReducer(),
    reportingReasons: reportingReasonsReducer(),
  })

  return (state = initialState, action) => {
    switch (action.type) {
      default:
        return state
    }
  }
}
